'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:train:ringtone');
}

var _invoke = require('../invoke');

/**
 *
 * @memberof train
 * @static
 * @name ringtone
 * @param {Number} loop 时长
 * @return {Promise}
 * @example
 *  hbnb.train.ringtone()
 *      .then(function() {});
 */
module.exports = function(duration) {
    if (process.env.NODE_ENV !== 'production') {
        debug('duration is %s', duration);
    }

    var p = new Promise(function(resolve, reject) {
        _invoke('train', 'ringtone', {
            duration: duration,
            callback: function() {
                resolve();
            },
            errback: function() {
                reject();
            }
        });
    });

    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/train/ringtone.js
// module id = 632
// module chunks = 0